// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/group/owners.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'owners',
	post: false,
	require: function(config, filter) { return sorted('owners', filter) > 0 && config.ownerType !== F.OWNER_USER },
	run: function(config, filter, data, query) {
		query.order('COUNT(DISTINCT(c.user_id))', sortReverse('owners', filter), sortPriority('owners', filter))
	}
}
